import './AxisTickWithTruncation.css';
export var directionValue = 'var(--_p2dhey0-2-0-1)';
export var tickStyle = '_p2dhey2-2-0-1';
export var widthContainer = 'var(--_p2dhey1-2-0-1)';